module.exports = __webpack_public_path__ + "list-close.png?b9b9f76bbc91647b6a1625e489b66c67";